<template>
  <div class="container">
    <div class="block">
      <div class="title-wrap">
        <div class="title-name">基础信息</div>
      </div>
      <div class="content-inner-wrap">
        <div class="studio-info" :data-studioid="studioId">
          <img class="avatar" :src="studioHead" />
          <div class="info">
            <h2>{{ studioName }}</h2>
            <p>室长：{{ leaderName }}</p>
            <p>工作室ID: {{ studioId }}</p>
          </div>
        </div>
        <div class="info-item studio-desc">
          <div class="label">简介：</div>
          <div class="details">{{ description }}</div>
        </div>
        <div class="info-item studio-notice">
          <div class="label">公告：</div>
          <div class="details">
            {{ notice }}
          </div>
        </div>
        <van-loading
          class="img-loading"
          type="spinner"
          color="#fd9b21"
          size="24px"
          v-show="baseInfoLoading"
        />
      </div>
    </div>
    <div class="block block-myProfit">
      <div class="title-wrap">
        <div class="title-name">我的信息</div>
      </div>
      <div class="content-inner-wrap">
        <ul class="myProfitItems">
          <li>
            <p>已加入</p>
            <label>{{ join_time | areadyJoinTime }}<i>天</i></label>
          </li>
          <li>
            <p>职位</p>
            <label>{{ position | memberType }}</label>
          </li>
          <li>
            <p>我的作品</p>
            <label>{{ my_map_count }}</label>
          </li>
          <!--   <li>
          <p>作品收益</p>
          <label>{{total_money}}</label>
        </li>   -->
        </ul>
      </div>
    </div>
    <!-- <div class="block-wrap"> -->
    <div class="block block-members">
      <div class="title-wrap">
        <div class="title-name">成员列表</div>
      </div>
      <div class="content-inner-wrap">
        <my-table :tableData="membersData" :tableField="membersDataField">
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'position'">{{
              scope.row.value | positionName
            }}</span>
          </template>
        </my-table>
        <div class="data-filter-page">
          <span>共{{ total_count_member }}个成员</span>
          <Pagination
            :tableInfo="mPagination"
            @changCurrentPage="memberPageChange"
          ></Pagination>
        </div>
        <van-loading
          class="img-loading"
          type="spinner"
          color="#fd9b21"
          size="24px"
          v-show="memberListLoading"
        />
      </div>
    </div>
    <div class="block block-rank">
      <div class="title-wrap">
        <div class="title-name">作品列表</div>
      </div>
      <div class="content-inner-wrap">
        <div class="rankItems">
          <div
            class="rankItem"
            v-for="(item, index) in productRankData"
            :key="index"
          >
            <img :src="item.thumb_url" />
            <div class="rankInfo">
              <p>{{ item.name }}</p>
              <p class="author">
                作者：<label>{{ item.uin_name }}</label>
              </p>
              <div class="rankData">
                <div class="downloads">{{ item.download_count }}</div>
                <div class="favorite">{{ item.collectc }}</div>
                <div class="toukuai">{{ item.tips_total }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="data-filter-page">
          <span>共{{ total_count_rank }}个作品</span>
          <Pagination
            :tableInfo="rPagination"
            @changCurrentPage="rankPageChange"
          ></Pagination>
        </div>
        <van-loading
          class="img-loading"
          type="spinner"
          color="#fd9b21"
          size="24px"
          v-show="rankListLoading"
        />
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
import {
  getStudioDetail,
  getStudioIncomeOverview,
  getStudioMembers,
  getStudioMemberCount,
  getStudioProductList,
} from '@/api/studio';
import {
  STUDIO_POSITION,
  ONE_DAY,
  NOTICE_DEFAULT,
  DESCRIPTION_DEFAULT,
} from './CONST';
import Pagination from '../../views/income/components/pagination.vue';
import MyTable from '../../components/MyTable.vue';

export default {
  components: {
    Pagination,
    MyTable,
  },
  data() {
    return {
      membersDataField: [
        { label: '名字', prop: 'name' },
        { label: '', prop: '' },
        { label: '迷你号', prop: 'uin' },
        { label: '类型', prop: 'position' },
      ],
      membersData: [],
      productRankData: [],
      description: DESCRIPTION_DEFAULT,
      notice: NOTICE_DEFAULT,
      studioName: '',
      studioHead: '',
      studioId: 0,
      leaderName: '',
      rPagination: {
        page: 1,
        page_size: 6,
        pageSize: 6,
        total: 0,
        showSize: 4,
      },
      mPagination: {
        page: 1,
        page_size: 5,
        pageSize: 5,
        total: 0,
        showSize: 4,
      },
      total_count_member: 1,
      total_count_rank: 1,
      total_money: 0,
      memberListLoading: false,
      rankListLoading: false,
      baseInfoLoading: false,
      my_map_count: 0,
      vip_member: 0,
      join_time: 0,
      position: 2,
    };
  },
  async mounted() {
    this.Report('view', 'StudioPage', { v3: 'member' });
    this.getBaseInfo();
    getStudioIncomeOverview().then(res => {
      let { total_money } = res.data;
      this.total_money = total_money;
    });
    this.getRankList();
    let res = await getStudioMemberCount({ json: 1 });
    let { count } = res.data;
    this.total_count_member = parseInt(count, 10);
    this.mPagination.total = this.total_count_member;
    this.getMemberList();
  },
  filters: {
    positionName(position) {
      return STUDIO_POSITION[position].value;
    },
    areadyJoinTime(time) {
      console.log('areadyJoinTime---', time);
      if (Number.isNaN(time)) return 0;
      let diffDay = Date.now() - time * 1000;
      return Math.floor(diffDay / ONE_DAY);
    },
    memberType(position) {
      return STUDIO_POSITION[position].value;
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    exitStudioTips() {
      this.$alert('请前往游戏客户端 - 个人中心 - 工作室 中申请退出', '提示', {
        confirmButtonText: '确定',
        callback: action => console.log(action),
      });
    },
    handleBaseInfo(baseInfo) {
      this.description = baseInfo.description || DESCRIPTION_DEFAULT;
      this.notice = baseInfo.notice || NOTICE_DEFAULT;
      this.studioName = baseInfo.name;
      this.studioHead = baseInfo.head;
      this.leaderName = baseInfo.leader_name;
      this.studioId = baseInfo.studio_id;
      this.my_map_count = baseInfo.my_map_count;
      this.vip_member = baseInfo.vip_member;
      this.join_time = baseInfo.join_time;
      this.position = baseInfo.position;
    },
    getBaseInfo() {
      let baseInfo = sessionStorage.getItem('studioBaseInfo');
      if (baseInfo) {
        baseInfo = JSON.parse(baseInfo);
        this.handleBaseInfo(baseInfo);
      } else {
        this.baseInfoLoading = false;
        getStudioDetail({ json: 1 }).then(res => {
          this.baseInfoLoading = true;
          baseInfo = res.data;
          this.handleBaseInfo(baseInfo);
          sessionStorage.setItem('studioBaseInfo', JSON.stringify(baseInfo));
        });
      }
    },
    memberPageChange(page) {
      this.mPagination.page = page;
      this.getMemberList();
    },
    rankPageChange(page) {
      this.rPagination.page = page;
      this.getRankList();
    },
    getMemberList() {
      this.memberListLoading = true;
      getStudioMembers({ json: 1, ...this.mPagination }).then(res => {
        this.memberListLoading = false;
        this.membersData = res.data || [];
      });
    },
    getRankList() {
      this.rankListLoading = true;
      getStudioProductList({ json: 1, ...this.rPagination }).then(res => {
        this.rankListLoading = false;
        let { count, list } = res.data;
        this.productRankData = list || [];
        this.total_count_rank = count;
        this.rPagination.total = count;
      });
    },
  },
};
</script>
<style
  src="../../assets/styles/introduce-common.less"
  lang="less"
  scoped
></style>
<style lang="less" scoped>
.block-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .block-members {
    width: 436px;
  }
  .block-rank {
    width: 596px;
  }
  .block .content-inner-wrap {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
.container .block-myProfit {
  .title-wrap {
    border-bottom: none;
    margin-bottom: 26px;
  }
}
.block {
  .content-inner-wrap {
    .studio-info {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .avatar {
        margin-right: 22px;
        width: 100px;
        height: 100px;
        border-radius: 12px;
        border: 2px solid #f565a5;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        h2 {
          font-size: 32px;
          line-height: 42px;
          margin-bottom: 4px;
        }
        p {
          font-size: 28px;
          line-height: 38px;
        }
      }
    }
    .info-item {
      display: block;
      height: auto;
      overflow: hidden;
      margin-top: 20px;
      .label {
        width: 90px;
        float: left;
        font-size: 28px;
        line-height: 52px;
        color: #595959;
        white-space: nowrap;
      }
      .details {
        width: 536px;
        float: left;
        font-size: 28px;
        line-height: 52px;
        color: #262626;
      }
    }
    .myProfitItems {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-bottom: 30px;
      flex-flow: wrap;
      li {
        position: relative;
        width: 212px;
        text-align: left;
        flex: auto 0 1;
        text-align: center;
        margin: 36px auto;
        p {
          font-size: 24px;
          line-height: 32px;
          color: #595959;
          margin-bottom: 18px;
        }
        label {
          font-size: 36px;
          line-height: 48px;
          color: #fd9b21;
          i {
            font-size: 20px;
            line-height: 28px;
            margin-left: 17px;
            color: #262626;
            font-style: normal;
          }
        }
        &:after {
          display: block;
          content: '';
          width: 2px;
          height: 72px;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 0;
          margin: auto;
          background: #d9d9d9;
        }
        &:nth-child(3n)::after {
          display: none;
        }
      }
    }
    .data-filter-page {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      span {
        margin: 0 20px 0 0;
      }
    }
    .rankItem {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      margin-bottom: 20px;
      img {
        width: 200px;
        height: 120px;
        margin-right: 30px;
      }
      p {
        font-size: 28px;
        line-height: 38px;
        color: #262626;
        &.author {
          color: #595959;
          margin: 4px 0;
          label {
            color: #fd9b21;
          }
        }
      }
      .rankInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 500px;
      }
      .rankData {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-size: 28px;
        line-height: 38px;
        color: #595959;
        > div {
          padding-left: 48px;
          background-position: left center;
          background-repeat: no-repeat;
          background-size: 36px;
          margin-right: 48px;
        }
        .downloads {
          background-image: url('../../assets/images/icon-downloads.svg');
        }
        .toukuai {
          background-image: url('../../assets/images/icon-toukuai.svg');
        }
        .favorite {
          background-image: url('../../assets/images/icon-favorite.svg');
        }
      }
    }
  }
}
.block-wrap {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  .block {
    width: 516px;
    padding: 18px 31px 45px;
  }
}
</style>
